import React, { useState } from 'react';

function Home() {
    const [isDarkTheme, setIsDarkTheme] = useState(false);
    const [language, setLanguage] = useState('en');

    const toggleTheme = () => {
        setIsDarkTheme(!isDarkTheme);
    };

    const toggleLanguage = () => {
        setLanguage(language === 'en' ? 'ko' : 'en');
    };

    const themeStyles = {
        backgroundColor: isDarkTheme ? '#121212' : '#f9f9f9',
        color: isDarkTheme ? '#ffffff' : '#333',
        transition: 'background-color 0.3s, color 0.3s',
        minHeight: '100vh',
        fontFamily: 'Arial, sans-serif',
        lineHeight: '1.6',
    };

    const headerStyles = {
        backgroundColor: isDarkTheme ? '#1f1f1f' : '#007BFF',
        color: '#ffffff',
        padding: '20px',
        textAlign: 'center',
    };

    const sectionStyles = {
        textAlign: 'left',
        maxWidth: '1000px',
        margin: '20px auto',
        backgroundColor: isDarkTheme ? '#1e1e1e' : '#ffffff',
        color: isDarkTheme ? '#e0e0e0' : '#333',
        padding: '20px',
        borderRadius: '8px',
        boxShadow: isDarkTheme ? '0 4px 10px rgba(0, 0, 0, 0.5)' : '0 4px 10px rgba(0, 0, 0, 0.1)',
    };

    const footerStyles = {
        marginTop: '20px',
        color: isDarkTheme ? '#888' : '#666',
        textAlign: 'center',
        padding: '10px 0',
    };

    const buttonStyles = {
        backgroundColor: isDarkTheme ? '#007BFF' : '#333',
        color: '#ffffff',
        border: 'none',
        padding: '10px 15px',
        cursor: 'pointer',
        borderRadius: '5px',
        position: 'absolute',
        top: '10px',
        right: '0px',
        transition: 'background-color 0.3s',
    };

    const languageButtonStyles = {
        ...buttonStyles,
        right: '20px',
    };

    const content = {
        en: {
            title: 'Privacy Policy & Terms of Use',
            privacyPolicy: `
1. Information We Collect:
   - We collect personal information such as name, email, and usage data to improve the service.

2. How We Use Your Information:
   - Your information is used for creating videos, enhancing user experience, and improving app performance.

3. Data Sharing:
   - We do not sell or share your personal information with third parties except as necessary to provide the service.
   - However, we use Google AdMob for advertising, which may collect data such as device identifiers (e.g., IDFA) to serve personalized ads.
   - Google AdMob, as a third-party service provider, may collect and process information such as your device ID (IDFA), IP address, and interaction data in accordance with their own privacy policy.

4. User Consent and App Store Compliance:
   - In compliance with Apple's App Tracking Transparency (ATT) framework, we request tracking permission when the app launches on iOS devices running iOS 14 or higher.
   - If the user declines tracking, personalized ads are disabled and only non-targeted, contextual ads are displayed in accordance with Apple’s App Tracking Transparency guidelines.

5. Your Rights:
   - You have the right to access, modify, or delete your personal data.

6. Changes to This Policy:
   - This policy may be updated from time to time. Please review it regularly for any changes.
            `,
            termsOfUse: `
1. License Agreement:
   - You are granted a non-exclusive, non-transferable, limited license to use the app for personal, non-commercial purposes.

2. User Conduct:
   - You must not reverse-engineer, decompile, or modify any part of the app.

3. Intellectual Property:
   - All intellectual property rights in the app remain the property of the developers.
   - Content generated using the app remains your property.

4. Disclaimer:
   - The app is provided "as is" without any warranty.

5. Limitation of Liability:
   - The developers shall not be liable for damages arising out of or in connection with the use of the app.

6. Changes to the Terms:
   - Continued use of the app signifies your acceptance of the revised terms.

7. Contact:
   - For questions, contact pika.jessica777@gmail.com.
            `,
        },
        ko: {
            title: '개인정보 처리방침 & 이용 약관',
            privacyPolicy: `
1. 수집하는 정보:
   - 이름, 이메일, 사용 데이터를 수집하여 서비스를 개선합니다.

2. 정보 사용 방식:
   - 수집된 정보는 동영상 생성, 사용자 경험 향상 및 앱 성능 개선에 사용됩니다.

3. 데이터 공유:
   - 우리는 귀하의 개인 정보를 제3자에게 판매하거나 공유하지 않습니다.
   - 단, Google AdMob 광고 플랫폼을 통해 IDFA(광고 식별자)와 같은 장치 정보가 수집되어 맞춤형 광고에 사용될 수 있습니다.
   - Google AdMob은 제3자 서비스 제공자로서 자체 개인정보처리방침에 따라 귀하의 장치 ID, IP 주소, 상호작용 데이터를 수집 및 처리할 수 있습니다.

4. 사용자 동의 및 App Store 정책 준수:
   - iOS 14 이상에서 앱 실행 시 Apple의 ATT(앱 추적 투명성) 정책에 따라 사용자 추적 권한을 요청합니다.
   - 사용자가 추적을 거부한 경우, 개인화된 광고는 비활성화되며, 일반적인 맥락 광고만 표시됩니다.

5. 사용자 권리:
   - 귀하는 언제든지 자신의 개인정보에 대한 열람, 수정 또는 삭제를 요청할 수 있습니다.

6. 정책 변경:
   - 본 정책은 변경될 수 있으며, 중요한 변경 사항은 본 페이지에 공지됩니다.
            `,
            termsOfUse: `
1. 라이선스 동의:
   - 본 앱은 비독점적이고 양도 불가능한 제한적 라이선스로 개인 용도로 사용할 수 있습니다.

2. 사용자 행동:
   - 앱의 일부를 역설계, 디컴파일 또는 수정해서는 안 됩니다.

3. 지적 재산권:
   - 앱에 대한 모든 지적 재산권은 개발자에게 있으며, 앱으로 생성된 콘텐츠의 권리는 사용자에게 있습니다.

4. 면책 조항:
   - 본 앱은 "있는 그대로" 제공되며, 어떠한 보증도 제공하지 않습니다.

5. 책임 제한:
   - 앱 사용으로 발생한 손해에 대해 개발자는 책임지지 않습니다.

6. 약관 변경:
   - 앱을 계속 사용하는 경우, 변경된 약관에 동의한 것으로 간주됩니다.

7. 문의:
   - 문의: pika.jessica777@gmail.com
            `,
        },
    };

    return (
        <div style={themeStyles}>
            <button style={languageButtonStyles} onClick={toggleLanguage}>
                {language === 'en' ? 'Korean' : 'English'}
            </button>
            <header style={headerStyles}>
                <h1>Pika Art: AI Video Generator — {content[language].title}</h1>
            </header>
            <section style={sectionStyles}>
                <h2>Privacy Policy</h2>
                <pre>{content[language].privacyPolicy}</pre>
                <h2>Terms of Use (EULA)</h2>
                <pre>{content[language].termsOfUse}</pre>
            </section>
            <footer style={footerStyles}>
                <p>&copy; 2024 JessicaLabs. All rights reserved.</p>
            </footer>
        </div>
    );
}

export default Home;
